import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { BRANDS, PHONES } from '../content';
import PageHero from '../components/PageHero';
import FinalCTA from '../components/FinalCTA';
import { SEOHead } from '../components/SEOHead';

export default function Markalar() {
  return (
    <main data-testid="markalar-page" style={{ background: 'var(--bg)' }}>
      <SEOHead path="/markalarimiz" />
      <PageHero
        breadcrumb="Markalarımız"
        headline="Premium Markalar."
        accentText="Profesyonel Servis."
        sub="Dünya liderlerinin orijinal lastikleriyle çalışıyoruz. Kaliteden ödün vermiyoruz."
        badge="Yetkili Servis Noktası"
      />

      {/* ─── BRAND GRID ─── */}
      <section className="section" style={{ background: 'var(--bg)' }}>
        <div className="wrap">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: '1.25rem',
          }}>
            {BRANDS.map((brand, i) => (
              <motion.div
                key={brand.name}
                data-testid={`markalar-brand-${brand.name.toLowerCase()}`}
                initial={{ opacity: 0, scale: .92 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: .4, delay: i * .06 }}
                style={{
                  background: 'var(--card)',
                  border: '1px solid var(--border)',
                  borderRadius: 'var(--rl)',
                  padding: '2.5rem 1.5rem',
                  textAlign: 'center',
                  transition: 'border-color .25s, background .25s, transform .2s, box-shadow .25s',
                  cursor: 'default',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = `${brand.color}50`;
                  e.currentTarget.style.background = 'var(--card2)';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = `0 12px 40px ${brand.color}15`;
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = 'var(--border)';
                  e.currentTarget.style.background = 'var(--card)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                {/* Logo */}
                <div style={{
                  width: '100%', height: 100,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: '#fff', borderRadius: 12,
                  padding: '1rem',
                  marginBottom: '1rem',
                }}>
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    loading="lazy"
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </div>
                <h3 style={{
                  fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700,
                  fontSize: '1.1rem', color: 'var(--text)', marginBottom: '.3rem',
                }}>{brand.name}</h3>
                <p style={{ fontSize: '.78rem', color: 'var(--text2)' }}>Orijinal lastik servisi</p>
              </motion.div>
            ))}
          </div>

          {/* Other brands note */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: .5 }}
            style={{
              marginTop: '2.5rem',
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--rl)',
              padding: '2.25rem',
              textAlign: 'center',
            }}
          >
            <h3 style={{
              fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700,
              fontSize: '1.1rem', color: 'var(--text)', marginBottom: '.5rem',
            }}>
              Farklı Bir Marka mı?
            </h3>
            <p style={{ color: 'var(--text2)', fontSize: '.88rem', lineHeight: 1.7, maxWidth: 480, margin: '0 auto .875rem' }}>
              Listede olmayan bir lastik markası için de yardımcı olabiliriz. Hemen arayın ve ihtiyacınızı bildirin.
            </p>
            <a
              href={PHONES.main_tel}
              data-testid="markalar-call"
              className="btn btn-primary btn-sm num"
              style={{ gap: '.4rem' }}
            >
              <Phone size={14} /> Sorun, Çözelim
            </a>
          </motion.div>
        </div>
      </section>

      <FinalCTA headline="Markanız Ne Olursa Olsun." sub="Biz Hazırız." />
    </main>
  );
}
